import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-read-line text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-foreground-50 font-heading">韩国漫画网</span>
              </Link>
              <p className="text-sm leading-relaxed text-foreground-400">
                韩国漫画网是专业的免费韩漫在线阅读平台，为您提供海量韩漫资源，支持完整在线观看，每日同步更新热门韩漫，让您随时随地畅享精彩故事。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">漫画分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(1, 7).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    全部漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/completed" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    已完结漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    热门恋爱漫画
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">免责声明</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                本站所有漫画资源均来自互联网，仅供学习交流使用。如果您喜欢某部作品，请购买正版支持原作者。如有侵权，请联系我们删除。
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} 韩国漫画网 - 韩漫画免费网站,漫画大全,韩漫完整在线观看
            </p>
            <div className="flex items-center gap-5">
              <Link to="/" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              <Link to="/category/all" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap">全部漫画</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}